<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item to="/collaborativeList" @click="updateListCategory('collaborativeList')">Collaborative List
      </b-breadcrumb-item>
      <b-breadcrumb-item href="#collaborativeToDoListName" active>{{toDoListDetails.toDoListName}}</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">{{toDoListDetails.toDoListName}}</h1>
    <p v-if="toDoListDetails.toDoListDescription">{{toDoListDetails.toDoListDescription}}</p>
    <p v-else>No description provided.</p>
    <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold">
      <b-tab title="All Task" @click="updateCollaborativeTaskListSelectedTab('All Task')">
        <div class="task-container">
          <div v-if="showPlaceholderImageAllTask && !hideWhenInitialLoadAllTask" class="no-task-container">
            <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
                   alt="No task picture"></b-img>
            <h2>Team task list is empty</h2>
            <p>Your team's collaborative tasks will be shown here</p>
          </div>
          <regular-with-assignee-task-cell v-for="collaborativeTask in collaborativeTaskDocuments"
                                           :key="collaborativeTask.taskId"
                                           :task-details="collaborativeTask"></regular-with-assignee-task-cell>
        </div>
      </b-tab>
      <b-tab title="My Task" @click="updateCollaborativeTaskListSelectedTab('My Task')">
        <div class="task-container">
          <div v-if="showPlaceholderImageMyTask && !hideWhenInitialLoadMyTask" class="no-task-container">
            <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
                   alt="No task picture"></b-img>
            <h2>No assigned task</h2>
            <p>Task assigned to you will be shown here</p>
          </div>
          <regular-with-assignee-task-cell v-for="myTask in myTaskDocuments" :key="myTask.taskId"
                                           :task-details="myTask"></regular-with-assignee-task-cell>
        </div>
      </b-tab>
      <b-tab title="Overview" @click="updateCollaborativeTaskListSelectedTab('Overview')">
        <div class="task-container">
          <h2 class="section-title">Collaborative List Details</h2>
          <div class="input-container">
            <b-row>
              <b-col>
                <label class="input-title">List name</label>
                <b-form-input
                    type="text"
                    :state="informationValidation.isCollaborativeListNameProvided"
                    v-model="currentToDoListName"
                    :disabled="!isCollaborativeListAdministrator"></b-form-input>

                <b-form-text v-if="!isCollaborativeListAdministrator">Only list administrator can edit this information.</b-form-text>

                <b-form-invalid-feedback v-if="!informationValidation.isListNameProvided">
                  This field must not be empty.
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
          </div>
          <div class="input-container">
            <b-row>
              <b-col>
                <label class="input-title">List description (optional)</label>
                <b-form-input
                    type="text"
                    v-model="currentToDoListDescription"
                    :disabled="!isCollaborativeListAdministrator"></b-form-input>

                <b-form-text v-if="!isCollaborativeListAdministrator">Only list administrator can edit this information.</b-form-text>
              </b-col>
            </b-row>
          </div>
          <b-button class="secondary-input-button" block @click="updateListDetails" :disabled="!isCollaborativeListAdministrator">Update list details</b-button>
          <hr>
          <h2 class="section-title">Collaborators</h2>
          <p>Owner: {{ toDoListDetails.ownerName }}</p>
          <p>Number of administrator(s): {{ toDoListCollaboratorInformation.numberOfListAdministrator }}</p>
          <p>Number of member(s): {{ toDoListCollaboratorInformation.numberOfListMember }}</p>
          <p>Total number of collaborators: {{ toDoListCollaboratorInformation.toDoListCollaboratorSize }}</p>
          <b-button class="secondary-input-button" @click="navigateToViewCollaborators" block>View collaborators
          </b-button>
        </div>
      </b-tab>
    </b-tabs>
    <fab
        v-if="collaborativeTaskListSelectedTab === 'All Task' && isCollaborativeListAdministrator"
        position="bottom-right"
        bg-color="#565A7B"
        icon-size="small"
        @click.native="openCreationModal"
    ></fab>
  </div>
</template>

<script>
  import RegularWithAssigneeTaskCell from "../table_cells/task_cells/RegularWithAssigneeTaskCell"

  import {mapActions, mapGetters} from 'vuex'
  import router from "../../router";
  import {db} from "../../main";
  import {required} from "vuelidate/lib/validators"
  import fab from 'vue-fab'

  export default {
    name: "CollaborativeTaskList",
    components: {
      regularWithAssigneeTaskCell: RegularWithAssigneeTaskCell,
      fab
    },
    data() {
      return {
        showPlaceholderImageAllTask: null,
        showPlaceholderImageMyTask: null,
        hideWhenInitialLoadAllTask: true,
        hideWhenInitialLoadMyTask: true,
        toDoListId: null,
        toDoListDetails: {},
        currentToDoListName: '',
        currentToDoListDescription: '',
        informationValidation: {
          isCollaborativeListNameProvided: null
        },
        toDoListCollaboratorInformation: {
          toDoListCollaboratorSize: 0,
          numberOfListAdministrator: 0,
          numberOfListMember: 0
        },
        collaborativeTaskDocuments: [],
        myTaskDocuments: []
      }
    },
    validations: {
      currentToDoListName: {
        required
      }
    },
    methods: {
      ...mapActions([
        "updateListCategory",
        "updateCollaborativeTaskListSelectedTab"
      ]),
      openCreationModal() {
        this.$store.dispatch('setupCreationModal')
        this.showModal('creation-modal')
      },
      getSortedCollaborativeTaskData(sortProperties) {
        if (sortProperties.sortTypeSelected === 'Creation time' && sortProperties.sortDirectionSelected === 'Ascending') {
          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            this.$bind(
              'collaborativeTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('toDoListId', '==', this.toDoListId)
                .orderBy('taskCreationTime', 'asc')
            ).then(() => {
              if (this.collaborativeTaskDocuments.length === 0) {
                this.showPlaceholderImageAllTask = true
              }
              this.hideWhenInitialLoadAllTask = false
            })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            this.$bind(
              'myTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('assigneeId', '==', this.$store.getters.user.data.id)
                .orderBy('taskCreationTime', 'asc')
            ).then(() => {
              if (this.myTaskDocuments.length === 0) {
                this.showPlaceholderImageMyTask = true
              }
              this.hideWhenInitialLoadMyTask = false
            })
          }
        } else if (sortProperties.sortTypeSelected === 'Creation time' && sortProperties.sortDirectionSelected === 'Descending') {
          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            this.$bind(
              'collaborativeTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('toDoListId', '==', this.toDoListId)
                .orderBy('taskCreationTime', 'desc')
            ).then(() => {
              if (this.collaborativeTaskDocuments.length === 0) {
                this.showPlaceholderImageAllTask = true
              }
              this.hideWhenInitialLoadAllTask = false
            })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            this.$bind(
              'myTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('assigneeId', '==', this.$store.getters.user.data.id)
                .orderBy('taskCreationTime', 'desc')
            ).then(() => {
              if (this.myTaskDocuments.length === 0) {
                this.showPlaceholderImageMyTask = true
              }
              this.hideWhenInitialLoadMyTask = false
            })
          }
        } else if (sortProperties.sortTypeSelected === 'Task name' && sortProperties.sortDirectionSelected === 'Ascending') {

          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            this.$bind(
              'collaborativeTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('toDoListId', '==', this.toDoListId)
                .orderBy('taskName', 'asc')
            ).then(() => {
              if (this.collaborativeTaskDocuments.length === 0) {
                this.showPlaceholderImageAllTask = true
              }
              this.hideWhenInitialLoadAllTask = false
            })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            this.$bind(
              'myTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('assigneeId', '==', this.$store.getters.user.data.id)
                .orderBy('taskName', 'asc')
            ).then(() => {
              if (this.myTaskDocuments.length === 0) {
                this.showPlaceholderImageMyTask = true
              }
              this.hideWhenInitialLoadMyTask = false
            })
          }
        } else if (sortProperties.sortTypeSelected === 'Task name' && sortProperties.sortDirectionSelected === 'Descending') {
          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            this.$bind(
              'collaborativeTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('toDoListId', '==', this.toDoListId)
                .orderBy('taskName', 'desc')
            ).then(() => {
              if (this.collaborativeTaskDocuments.length === 0) {
                this.showPlaceholderImageAllTask = true
              }
              this.hideWhenInitialLoadAllTask = false
            })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            this.$bind(
              'myTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('assigneeId', '==', this.$store.getters.user.data.id)
                .orderBy('taskName', 'desc')
            ).then(() => {
              if (this.myTaskDocuments.length === 0) {
                this.showPlaceholderImageMyTask = true
              }
              this.hideWhenInitialLoadMyTask = false
            })
          }
        } else if (sortProperties.sortTypeSelected === 'Priority' && sortProperties.sortDirectionSelected === 'Ascending') {
          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            this.$bind(
              'collaborativeTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('toDoListId', '==', this.toDoListId)
                .orderBy('priority', 'asc')
            ).then(() => {
              if (this.collaborativeTaskDocuments.length === 0) {
                this.showPlaceholderImageAllTask = true
              }
              this.hideWhenInitialLoadAllTask = false
            })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            this.$bind(
              'myTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('assigneeId', '==', this.$store.getters.user.data.id)
                .orderBy('priority', 'asc')
            ).then(() => {
              if (this.myTaskDocuments.length === 0) {
                this.showPlaceholderImageMyTask = true
              }
              this.hideWhenInitialLoadMyTask = false
            })
          }
        } else if (sortProperties.sortTypeSelected === 'Priority' && sortProperties.sortDirectionSelected === 'Descending') {
          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            this.$bind(
              'collaborativeTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('toDoListId', '==', this.toDoListId)
                .orderBy('priority', 'desc')
            ).then(() => {
              if (this.collaborativeTaskDocuments.length === 0) {
                this.showPlaceholderImageAllTask = true
              }
              this.hideWhenInitialLoadAllTask = false
            })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            this.$bind(
              'myTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('assigneeId', '==', this.$store.getters.user.data.id)
                .orderBy('priority', 'desc')
            ).then(() => {
              if (this.myTaskDocuments.length === 0) {
                this.showPlaceholderImageMyTask = true
              }
              this.hideWhenInitialLoadMyTask = false
            })
          }
        }
      },
      getFilteredCollaborativeTaskData(filterProperties) {
        if (filterProperties.filterTypeSelected === 'None') {
          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            this.$bind(
              'collaborativeTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('toDoListId', '==', this.toDoListId)
                .orderBy('taskCreationTime', 'asc')
            ).then(() => {
              if (this.collaborativeTaskDocuments.length === 0) {
                this.showPlaceholderImageAllTask = true
              }
              this.hideWhenInitialLoadAllTask = false
            })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            this.$bind(
              'myTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('assigneeId', '==', this.$store.getters.user.data.id)
                .orderBy('taskName', 'asc')
            ).then(() => {
              if (this.myTaskDocuments.length === 0) {
                this.showPlaceholderImageMyTask = true
              }
              this.hideWhenInitialLoadMyTask = false
            })
          }
        } else if (filterProperties.filterTypeSelected === 'Assigned task' && filterProperties.filterDirectionSelected === 'Ascending') {
          this.$bind(
            'collaborativeTaskDocuments',
            db
              .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .where('assigned', '==', true)
              .orderBy('taskName', 'asc')
          ).then(() => {
            if (this.collaborativeTaskDocuments.length === 0) {
              this.showPlaceholderImageAllTask = true
            }
            this.hideWhenInitialLoadAllTask = false
          })
        } else if (filterProperties.filterTypeSelected === 'Assigned task' && filterProperties.filterDirectionSelected === 'Descending') {
          this.$bind(
            'collaborativeTaskDocuments',
            db
              .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .where('assigned', '==', true)
              .orderBy('taskName', 'desc')
          ).then(() => {
            if (this.collaborativeTaskDocuments.length === 0) {
              this.showPlaceholderImageAllTask = true
            }
            this.hideWhenInitialLoadAllTask = false
          })
        } else if (filterProperties.filterTypeSelected === 'Unassigned task' && filterProperties.filterDirectionSelected === 'Ascending') {
          this.$bind(
            'collaborativeTaskDocuments',
            db
              .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .where('assigned', '==', false)
              .orderBy('taskName', 'asc')
          ).then(() => {
            if (this.collaborativeTaskDocuments.length === 0) {
              this.showPlaceholderImageAllTask = true
            }
            this.hideWhenInitialLoadAllTask = false
          })
        } else if (filterProperties.filterTypeSelected === 'Unassigned task' && filterProperties.filterDirectionSelected === 'Descending') {
          this.$bind(
            'collaborativeTaskDocuments',
            db
              .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .where('assigned', '==', false)
              .orderBy('taskName', 'desc')
          ).then(() => {
            if (this.collaborativeTaskDocuments.length === 0) {
              this.showPlaceholderImageAllTask = true
            }
            this.hideWhenInitialLoadAllTask = false
          })
        } else if (filterProperties.filterTypeSelected === 'Completed task' && filterProperties.filterDirectionSelected === 'Ascending') {
          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            this.$bind(
              'collaborativeTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('toDoListId', '==', this.toDoListId)
                .where('completed', '==', true)
                .orderBy('taskName', 'asc')
            ).then(() => {
              if (this.collaborativeTaskDocuments.length === 0) {
                this.showPlaceholderImageAllTask = true
              }
              this.hideWhenInitialLoadAllTask = false
            })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            this.$bind(
              'myTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('assigneeId', '==', this.$store.getters.user.data.id)
                .where('toDoListId', '==', this.toDoListId)
                .where('completed', '==', true)
                .orderBy('taskName', 'asc')
            ).then(() => {
              if (this.myTaskDocuments.length === 0) {
                this.showPlaceholderImageMyTask = true
              }
              this.hideWhenInitialLoadMyTask = false
            })
          }
        } else if (filterProperties.filterTypeSelected === 'Completed task' && filterProperties.filterDirectionSelected === 'Descending') {
          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            this.$bind(
              'collaborativeTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('toDoListId', '==', this.toDoListId)
                .where('completed', '==', true)
                .orderBy('taskName', 'desc')
            ).then(() => {
              if (this.collaborativeTaskDocuments.length === 0) {
                this.showPlaceholderImageAllTask = true
              }
              this.hideWhenInitialLoadAllTask = false
            })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            this.$bind(
              'myTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('assigneeId', '==', this.$store.getters.user.data.id)
                .where('toDoListId', '==', this.toDoListId)
                .where('completed', '==', true)
                .orderBy('taskName', 'desc')
            ).then(() => {
              if (this.myTaskDocuments.length === 0) {
                this.showPlaceholderImageMyTask = true
              }
              this.hideWhenInitialLoadMyTask = false
            })
          }
        } else if (filterProperties.filterTypeSelected === 'Incomplete task' && filterProperties.filterDirectionSelected === 'Ascending') {
          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            this.$bind(
              'collaborativeTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('toDoListId', '==', this.toDoListId)
                .where('completed', '==', false)
                .orderBy('taskName', 'asc')
            ).then(() => {
              if (this.collaborativeTaskDocuments.length === 0) {
                this.showPlaceholderImageAllTask = true
              }
              this.hideWhenInitialLoadAllTask = false
            })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            this.$bind(
              'myTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('assigneeId', '==', this.$store.getters.user.data.id)
                .where('toDoListId', '==', this.toDoListId)
                .where('completed', '==', false)
                .orderBy('taskName', 'asc')
            ).then(() => {
              if (this.myTaskDocuments.length === 0) {
                this.showPlaceholderImageMyTask = true
              }
              this.hideWhenInitialLoadMyTask = false
            })
          }
        } else if (filterProperties.filterTypeSelected === 'Incomplete task' && filterProperties.filterDirectionSelected === 'Descending') {
          if (this.collaborativeTaskListSelectedTab === 'All Task') {
            this.$bind(
              'collaborativeTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('toDoListId', '==', this.toDoListId)
                .where('completed', '==', false)
                .orderBy('taskName', 'desc')
            ).then(() => {
              if (this.collaborativeTaskDocuments.length === 0) {
                this.showPlaceholderImageAllTask = true
              }
              this.hideWhenInitialLoadAllTask = false
            })
          } else if (this.collaborativeTaskListSelectedTab === 'My Task') {
            this.$bind(
              'myTaskDocuments',
              db
                .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
                .where('assigneeId', '==', this.$store.getters.user.data.id)
                .where('toDoListId', '==', this.toDoListId)
                .where('completed', '==', false)
                .orderBy('taskName', 'desc')
            ).then(() => {
              if (this.myTaskDocuments.length === 0) {
                this.showPlaceholderImageMyTask = true
              }
              this.hideWhenInitialLoadMyTask = false
            })
          }
        }
      },
      getToDoListCollaboratorInformation() {
        db
          .collectionGroup('user_collaborative_to_do_list_participation')
          .where('collaborativeToDoListId', '==', this.toDoListId)
          .onSnapshot(querySnapshot => {
            const userCollaborativeToDoListParticipationObject = querySnapshot.docs.map(doc => doc.data())

            userCollaborativeToDoListParticipationObject.forEach(collaborator => {
              this.toDoListCollaboratorInformation.toDoListCollaboratorSize++

              if (collaborator.collaborativeToDoListRole === 'Administrator') {
                this.toDoListCollaboratorInformation.numberOfListAdministrator++
              } else {
                this.toDoListCollaboratorInformation.numberOfListMember++
              }
            })
          })
      },
      updateListDetails() {
        // check if all information is valid
        let isValid = true

        if (!this.$v.currentToDoListName.required) {
          this.informationValidation.isCollaborativeListNameProvided = false
          isValid = false
        } else {
          this.informationValidation.isCollaborativeListNameProvided = true
        }

        if (isValid) {
          db
            .collection('collaborative_to_do_lists')
            .doc(this.toDoListId)
            .update({
              toDoListName: this.currentToDoListName,
              toDoListDescription: this.currentToDoListDescription
            })
        }
      },
      navigateToViewCollaborators() {
        this.$store.dispatch('updateListCategory', 'viewCollaborators')
        router.push({
          name: 'View Collaborators',
          params: {collaborativeListId: this.toDoListId}
        })
      },
      showModal(id) {
        this.$root.$emit('bv::show::modal', id)
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    },
    computed: {
      ...mapGetters([
        "collaborativeTaskListSelectedTab",
        "isCollaborativeListAdministrator",
        "sortTaskListProperties",
        "filterTaskListProperties"
      ])
    },
    watch: {
      collaborativeTaskDocuments(newProperties, oldProperties) {
        this.showPlaceholderImageAllTask = this.collaborativeTaskDocuments.length === 0
      },
      myTaskDocuments(newProperties, oldProperties) {
        this.showPlaceholderImageMyTask = this.myTaskDocuments.length === 0
      },
      sortTaskListProperties(newSortProperties, oldSortProperties) {
        this.getSortedCollaborativeTaskData(newSortProperties)
      },
      filterTaskListProperties(newFilterProperties, oldFilterProperties) {
        this.getFilteredCollaborativeTaskData(newFilterProperties)
      }
    },
    mounted() {
      this.showModal('loading-modal')

      this.toDoListId = this.$route.params.collaborativeListId

      // retrieve the collaborator role
      db.collectionGroup('user_collaborative_to_do_list_participation')
        .where('collaborativeToDoListId', '==', this.toDoListId)
        .where('collaboratorId', '==', this.$store.getters.user.data.id)
        .get()
        .then(querySnapshot => {
          const userCollaborativeToDoListParticipatedObject = querySnapshot.docs.map(doc => doc.data())

          this.$store.dispatch('setIsCollaborativeListAdministrator', userCollaborativeToDoListParticipatedObject[0].collaborativeToDoListRole === 'Administrator')
            .then(() => {
              this.$store.dispatch('updateListCategory', 'collaborativeTaskList')
              this.hideModal('loading-modal')
            })
        })

      db.collection('collaborative_to_do_lists')
        .doc(this.toDoListId)
        .onSnapshot(doc => {
          this.toDoListDetails = doc.data()
          this.currentToDoListName = this.toDoListDetails.toDoListName
          this.currentToDoListDescription = this.toDoListDetails.toDoListDescription

          this.$store.dispatch('setCurrentToDoListName', this.toDoListDetails.toDoListName)
        })

      // initial retrieval of collaborative list task
      this.$store.dispatch('updateCollaborativeTaskListSelectedTab', 'My Task').then(() => {
        // retrieve the initial data for "My Task" tab
        this.getSortedCollaborativeTaskData({
          sortTypeSelected: 'Task name',
          sortDirectionSelected: 'Ascending'
        })

        this.$store.dispatch('updateCollaborativeTaskListSelectedTab', 'All Task').then(() => {
          // retrieve the initial data for "All Task" tab
          this.getSortedCollaborativeTaskData({
            sortTypeSelected: 'Task name',
            sortDirectionSelected: 'Ascending'
          })
        })
      })

      // retrieve the collaborator information
      this.getToDoListCollaboratorInformation()
    },
    destroyed() {
      this.$store.dispatch('setCurrentToDoListName', '')
    }
  }
</script>

<style scoped>
  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .no-task-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .no-task-picture {
    width: 375px;
    margin-bottom: 1em;
  }

  .task-container {
    height: 64vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  }

  .section-title {
    font-size: 1.5em;
    margin-bottom: 0.5em;
  }

  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    font-weight: bold;
  }

  .secondary-input-button {
    background-color: white;
    color: #212441;
    padding: 0.5em;
  }

  .secondary-input-button:hover {
    background-color: #212441;
    color: white;
    padding: 0.5em;
  }

</style>
